<i-assistance
  [versions]="versions"
  [email]="support?.supportEmail || '--'"
  [phone]="support?.supportPhoneNumber || '--'"
></i-assistance>
